import { FC } from 'react'
import { NavLink } from 'react-router'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'

import { useCurrentProduct, useCurrentRegion } from '@/modules/urlRouting/hooks'
import { SELECTOR_BOX_SX } from '@/modules/urlRouting/styles'
import { generatePathWithRegionId, useProductOptions } from '@/modules/urlRouting/utils'

const ProductSelectorMUI: FC = () => {
  const currentProduct = useCurrentProduct()
  const {
    data: { regionId },
  } = useCurrentRegion()

  const productOptions = useProductOptions()

  return (
    <Box sx={SELECTOR_BOX_SX}>
      <FormControl size="small" sx={{ width: '100%' }}>
        <InputLabel id="product-selector-mui-label">Product</InputLabel>
        <Select
          labelId="product-selector-mui-label"
          label="Product"
          value={productOptions.find(option => option.product === currentProduct)?.text}
        >
          {productOptions.map(option => (
            // @ts-ignore
            // These two libraries aren't too happy about having their typing mashed together,
            // but this works as intended.
            <MenuItem
              key={option.text}
              disabled={option.disabled}
              value={option.text}
              component={NavLink}
              // Disabled items have no landing page; the link is inert.
              to={
                option.landingPage
                  ? generatePathWithRegionId(option.landingPage, regionId)
                  : `/${regionId}`
              }
              sx={theme => ({ '&:hover': { color: theme.palette.primary.main } })}
            >
              {option.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default ProductSelectorMUI
